function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { message, Skeleton, Descriptions, QRCode, Result, Button, Modal, Tag, notification } from "antd";
import { Container, Row, Col } from "react-bootstrap";
import { CheckCircleFill, XCircleFill, HourglassSplit, QuestionCircleFill, TrashFill } from "react-bootstrap-icons";
import Common from "../../components/includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var ScanTicket = function ScanTicket() {
  var _useParams = useParams(),
    tid = _useParams.tid;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isSearchDataLoading = _useState2[0],
    setIsSearchDataLoading = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    ticket = _useState4[0],
    setTicket = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isTicketScanProcessing = _useState6[0],
    setIsTicketScanProcessing = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    user = _useState8[0],
    setUser = _useState8[1];
  var handleScanTicket = function handleScanTicket() {
    setIsTicketScanProcessing(true);
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("b", {
        children: ["La destruction du ticket N\xBA ", ticket.id, " pour ", ticket.price_schema_item.price.toLocaleString("Fr"), " GNF ?"]
      }),
      onOk: function onOk() {
        axios.post(Common.baseApiUrl + "scanticket", {
          ticket_id: ticket.id.toString(),
          user_id: Common.currentUser.id
        }).then(function (response) {
          if (response.data.status == 200) {
            notification.success({
              message: "Ok!",
              content: "Ticket validé avec succès"
            });
          } else {
            notification.error({
              message: "Erreur !",
              content: response.data.message
            });
          }
        })["catch"](function (error) {
          notification.error({
            message: "Erreur !",
            content: "Une erreur est survenue - Code " + error.toString()
          });
        })["finally"](function () {
          setIsTicketScanProcessing(false);
        });
      },
      onCancel: function onCancel() {
        setIsTicketScanProcessing(false);
      }
    });
  };
  useEffect(function () {
    var req = Common.currentUser == null || Common.currentUser == 'undefined' ? Common.baseApiUrl + 'getticket/' + tid.toString() + "/" + null : Common.baseApiUrl + 'getticket/' + tid.toString() + "/" + Common.currentUser.id.toString();
    axios.get(req).then(function (response) {
      if (response.data.status == 200 && response.data.ticket.id == tid) {
        setTicket(response.data.ticket);
        setUser(response.data.user);
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue " + error.toString(),
        delay: 4
      });
    })["finally"](function () {
      setIsSearchDataLoading(false);
    });
  }, [tid]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isSearchDataLoading ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            children: /*#__PURE__*/_jsx(Skeleton, {
              active: true
            })
          })
        })
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsxs("div", {
        style: {
          background: "#E9E9E7",
          padding: "25px 0px",
          textAlign: "center"
        },
        children: [ticket && /*#__PURE__*/_jsx("div", {
          className: "stcover",
          style: {
            backgroundImage: 'url(' + ticket.event.image_file + ')',
            width: "100%"
          }
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsx(Row, {
            children: /*#__PURE__*/_jsxs(Col, {
              children: [isSearchDataLoading == false && ticket == null && /*#__PURE__*/_jsxs("div", {
                style: {
                  textAlign: "center"
                },
                children: [/*#__PURE__*/_jsx(QuestionCircleFill, {
                  size: 85,
                  style: {
                    color: "#AFA09D"
                  }
                }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h3", {
                  children: "Ticket introuvable !"
                })]
              }), ticket != null && /*#__PURE__*/_jsxs("div", {
                style: {
                  textAlign: "center"
                },
                children: [/*#__PURE__*/_jsx(QRCode, {
                  errorLevel: "H",
                  size: 150,
                  style: {
                    margin: "0 auto"
                  },
                  iconSize: 150 / 4,
                  value: "https://hello.utilesoft.app/#/az/scanticket/" + tid.toString()
                }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("span", {
                  children: ticket.id
                }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), ticket && /*#__PURE__*/_jsx(Tag, {
                  color: ticket.price_schema_item.color,
                  children: ticket.price_schema_item.label
                }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), user != null && (user.role == 901 || user.role == 701) && ticket.status == 0 && /*#__PURE__*/_jsx(Button, {
                  type: "primary",
                  onClick: handleScanTicket,
                  loading: isTicketScanProcessing,
                  children: /*#__PURE__*/_jsxs("b", {
                    children: [/*#__PURE__*/_jsx(TrashFill, {
                      size: 24
                    }), " DETRUIRE"]
                  })
                }), ticket.status != 0 && /*#__PURE__*/_jsx(Result, {
                  status: "warning",
                  title: "Ce ticket \xE0 \xE9t\xE9 utilis\xE9 !"
                }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("p", {
                  style: {
                    color: "A7A7A6"
                  },
                  children: [ticket && ticket.event && ticket.event.organization && ticket.event.organization.label, " , 2024, Tous droits reserv\xE9s"]
                })]
              })]
            })
          })
        })]
      })
    })
  });
};
export default ScanTicket;